import { render, staticRenderFns } from "./SkeletonCategory.vue?vue&type=template&id=46bc489a&"
import script from "./SkeletonCategory.vue?vue&type=script&lang=js&"
export * from "./SkeletonCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports